module.exports = __webpack_public_path__ + "static/media/8.8e1d5bfb.svg";